export default "/_next/static/media/tutorial-02.7d9201ca6aa9101285ef555cea3cccf0.jpg";